// Import Swiper styles
import "swiper/css";
import "swiper/css/a11y";
import "swiper/css/navigation";
import "../../theme/SwiperOverrides.css";

import * as styles from "./DogCardCarousel.module.scss";

import React, { useCallback, useState } from "react";
import { A11y, Navigation, Virtual } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import DogCarouselCard from "../SignPostCards/DogCarouselCard";

import { useClientSide } from "../../hooks/useClientSide";
import useWindowWidth from "../../hooks/useWindowWidth";
import { Pagination } from "../Pagination/Pagination";
import PlaceholderDogCarouselCard from "../SignPostCards/PlaceholderDogCarouselCard/PlaceholderDogCarouselCard";
import type { ButtonProps } from "../common";
export interface DogCardCarouselProps {
	dogs: DogsTrust.DogData[];
	showAllProps?: ButtonProps;
}

export const DogCardCarousel: React.FC<DogCardCarouselProps> = ({ dogs }) => {
	const isClientSide = useClientSide();
	const [swiper, setSwiper] = useState(null);
	const [currentSlide, setCurrentSlide] = useState(0);

	const prevSlide = () => swiper?.activeIndex > 0 && swiper?.slidePrev();
	const nextSlide = () =>
		swiper?.activeIndex < dogs.length - 2 && swiper?.slideNext();
	const windowWidth = useWindowWidth();

	const getVisibleCardCount = useCallback((windowWidth: number) => {
		if (windowWidth >= 1200) return 4;
		if (windowWidth >= 740) return 3;
		return 2;
	}, []);

	if (!isClientSide) return <div className={styles.swiperwrapper} />;

	return (
		<>
			<div className={styles.swiperwrapper}>
				<Swiper
					key={dogs.length}
					className={styles.swiper}
					modules={[Virtual, Navigation, A11y]}
					initialSlide={0}
					edgeSwipeThreshold={10}
					onSwiper={(swiper) => {
						setSwiper(swiper);
					}}
					onSlideChange={(swiper) => setCurrentSlide(swiper.activeIndex)}
					breakpoints={{
						320: {
							slidesPerView: getVisibleCardCount(320) + 0.25,
							enabled: dogs.length > getVisibleCardCount(320),
						},
						740: {
							slidesPerView: getVisibleCardCount(740) + 0.25,
							enabled: dogs.length > getVisibleCardCount(740),
						},

						1200: {
							slidesPerView: getVisibleCardCount(1200),
							enabled: dogs.length > getVisibleCardCount(1200),
						},
					}}
				>
					{dogs.length > 0
						? dogs.map((dog) => (
								<SwiperSlide key={dog.apiKey}>
									<DogCarouselCard dog={dog} />
								</SwiperSlide>
							))
						: [1, 2, 3, 4].map((x) => (
								<SwiperSlide key={x}>
									<PlaceholderDogCarouselCard />
								</SwiperSlide>
							))}
				</Swiper>
			</div>
			<div className={styles.pagination}>
				<Pagination
					onFirstClick={() => swiper?.slideTo(0)}
					onPreviousClick={prevSlide}
					onNextClick={nextSlide}
					onLastClick={() => swiper?.slideTo(dogs.length - 1)}
					firstDisabled={currentSlide === 0}
					previousDisabled={currentSlide === 0}
					nextDisabled={
						currentSlide >= dogs.length - getVisibleCardCount(windowWidth)
					}
					lastDisabled={
						currentSlide === dogs.length - getVisibleCardCount(windowWidth)
					}
					position={currentSlide}
					total={dogs.length}
					slim={true}
					noOffset={true}
				/>
			</div>
		</>
	);
};

export default DogCardCarousel;
